import TourPageCategoryTile from 'components/Tours/TourPageCategoryTile'
import { useAppSelector } from 'hooks/reduxHooks'
import useTailorMadeTour from 'hooks/TourV2/useTailorMadeTour'
import { formatCurrency } from 'lib/format/formatCurrencyIntl'
import React, { useMemo } from 'react'
import { isEnabledForFeature } from 'lib/config/featureFlagUtils'
import config from 'constants/config'

interface Props {
  category: App.Tours.CategoryData;
}

function TourPageTailorMadeTourCategoryTile(props: Props) {
  const tailorMadeTour = useTailorMadeTour()
  const region = useAppSelector(state => state.geo.currentRegionCode)
  const currency = useAppSelector(state => state.geo.currentCurrency)
  const { category } = props

  const categoryUpdated = useMemo(() => {
    return {
      ...category,
      subText: `Crafted specifically for you with just a ${tailorMadeTour.data?.fee ? formatCurrency(tailorMadeTour.data.fee, currency, region) : ''} deposit`,
    }
  }, [category, tailorMadeTour.data?.fee, currency, region])

  const enableFeature = useMemo(() => {
    return config.TAILOR_MADE_TOURS_REGIONS && isEnabledForFeature(config.TAILOR_MADE_TOURS_REGIONS, region)
  }, [region])

  if (!enableFeature) {
    return null
  }
  return <TourPageCategoryTile
    actionText="Request"
    toUrl="/campaign/tailor-made-tours"
    category={categoryUpdated}
  />
}

export default TourPageTailorMadeTourCategoryTile
